export type DisplayPayload = {
  $type: string;
  title?: string;
  [key: string]: unknown;
};

export function tryParseDisplayResult(result: string): DisplayPayload | null {
  try {
    const parsed = JSON.parse(result) as Record<string, unknown>;
    if (parsed.$type && typeof parsed.$type === "string")
      return parsed as DisplayPayload;
  } catch {
    /* not valid display JSON */
  }
  return null;
}
